import React, {ComponentProps} from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSwitch from '@material-ui/core/Switch';

interface Props extends Omit<ComponentProps<typeof FormControlLabel>, 'onChange' | 'control'> {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: boolean;
}

export const Switch: React.FC<Props> = ({onChange, value, name, ...props}) => {
  return (
    <FormControlLabel
      {...props}
      control={<MuiSwitch checked={value} onChange={onChange} name={name} />}
    />
  );
};
